import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';

import { type ContractApi, contractApiSchema } from '../../models';
import { logger } from '../../utils/logger';

const contracts = fetcher.extend(() => ({ prefixUrl: `${API.CONTRACTS}` }));

export const updateContract = async (
  key: string,
  payload: ContractApi,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await contracts.put(key, { json: payload, signal }).json(contractApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
